import api from './api';

/**
 * Service centré sur les notifications de l'utilisateur courant.
 */
const notificationService = {
  /**
   * Liste paginée des notifications de l'utilisateur courant.
   * @param {object} [options]
   * @param {number} [options.limit=20]
   * @param {number} [options.offset=0]
   * @param {boolean} [options.unreadOnly=false]
   */
  list: async ({ limit = 20, offset = 0, unreadOnly = false, type } = {}, options = {}) => {
    try {
      const response = await api.get('/notifications', {
        params: {
          limit,
          offset,
          unread_only: unreadOnly ? 'true' : undefined,
          type: type || undefined
        },
        ...options
      });
      return response;
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      console.error('Erreur lors de la récupération des notifications:', error);
      throw error;
    }
  },

  /** Résumé (compteurs, total, non lues, etc.). */
  summary: async (options = {}) => {
    try {
      return await api.get('/notifications/summary', options);
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      console.error('Erreur lors de la récupération du résumé des notifications:', error);
      throw error;
    }
  },

  /** Marque une notification comme lue. */
  markAsRead: async (id) => {
    try {
      return await api.patch(`/notifications/${id}/read`);
    } catch (error) {
      console.error('Erreur lors du marquage de la notification:', error);
      throw error;
    }
  },

  /** Marque toutes les notifications de l'utilisateur courant comme lues. */
  markAllAsRead: async () => {
    try {
      return await api.patch('/notifications/read-all');
    } catch (error) {
      console.error('Erreur lors du marquage groupé:', error);
      throw error;
    }
  },

  /** Supprime une notification de l'utilisateur courant. */
  delete: async (id) => {
    try {
      return await api.delete(`/notifications/${id}`);
    } catch (error) {
      console.error('Erreur lors de la suppression de la notification:', error);
      throw error;
    }
  },

  /** Supprime toutes les notifications déjà lues. */
  deleteAllRead: async () => {
    try {
      return await api.delete('/notifications/read');
    } catch (error) {
      console.error('Erreur lors de la suppression des notifications lues:', error);
      throw error;
    }
  }
};

export default notificationService;
